import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { BasketStore } from '@features/basket';
import { SiteStore } from '@core/site/site.store';

@Component({
  selector: 'app-basket-button',
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './basket-button.component.html',
  styleUrl: './basket-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BasketButtonComponent {
  protected readonly basket = inject(BasketStore);
  protected readonly site = inject(SiteStore);

  protected openBasket(): void {
    this.site.openRightDrawer();
  }
}
